import { BACKEND_URL } from '../config/env';
import { getTokens } from './authService';

/**
 * Gets all galleries associated with the account from the database
 */
export const getGalleries = async () => {
	const { idToken } = getTokens();

	const response = await fetch(`${BACKEND_URL}/app/galleries`, {
		method: 'GET',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` }
	});

	const galleriesResponse = await response?.json();

	return galleriesResponse;
};

/**
 * Gets gallery stats for the given gallery ID
 */
export const getGalleryStats = async (galleryID) => {
	const { idToken } = getTokens();

	const response = await fetch(`${BACKEND_URL}/app/galleries/stats/${galleryID}`, {
		method: 'GET',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` }
	});

	const galleryStatsResponse = await response?.json();

	return galleryStatsResponse;
};

/**
 * Deletes a gallery from the database and from the bucket
 */
export const deleteGallery = async (galleryID) => {
	const { idToken } = getTokens();

	const response = await fetch(`${BACKEND_URL}/app/galleries/${galleryID}`, {
		method: 'DELETE',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` }
	});

	const galleryStatsResponse = await response?.json();

	console.log(`galleryStatsResponse: ${JSON.stringify(galleryStatsResponse)}`);

	return galleryStatsResponse;
};

/**
 * Creates a gallery instance in the database
 * @param {string} title - The gallery title
 * @param {string} description - The gallery description
 */
export const createGallery = async (title, description) => {
	const { idToken } = getTokens();

	const response = await fetch(`${BACKEND_URL}/app/galleries`, {
		method: 'POST',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` },
		body: JSON.stringify({ title, description })
	});

	const galleryResponse = await response?.json();
	return galleryResponse;
};

/**
 * Updates a gallery instance in the database
 * @param {string} galleryID - The id of the gallery to update
 * @param {any} data - The data to update the gallery with
 */
export const updateGallery = async (galleryID, data) => {
	const { idToken } = getTokens();

	await fetch(`${BACKEND_URL}/app/galleries/${galleryID}`, {
		method: 'PUT',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` },
		body: JSON.stringify(data)
	});
};

/**
 * Starts a task that creates a zip of all images in the gallery
 * @param {string} galleryID - The id of the gallery to zip
 * @param {any} galleryName - The name to be used for the zip file
 */
export const zipGallery = async (galleryID, galleryName) => {
	const { idToken } = getTokens();

	await fetch(`${BACKEND_URL}/app/galleries/zip/${galleryID}`, {
		method: 'POST',
		headers: { 'Content-type': 'application/json', Authorization: `Bearer ${idToken}` },
		body: JSON.stringify({ galleryName })
	});
};
